import { FC, useEffect } from 'react';
import { useAppContext, useSafeState } from '#hooks';
import { dashboardApi } from '#api';
import { BlacklistedUsers } from '#types';
import { blacklistedUsersTableHeaders } from '#globals';
import { HttpStatusCode } from 'axios';

export const BlacklistTable: FC = () => {

    const { setApiStatus, currentEnvironment } = useAppContext();
    const [isLoading, setIsLoading] = useSafeState<boolean>(true)
    const [blacklistedUsers, setBlacklistedUsers] = useSafeState<BlacklistedUsers[]>([]);
    const [selectedBlacklistedUserEmails, setSelectedBlacklistedUserEmails] = useSafeState<string[]>([])

    useEffect(
        () => {
            init();
        },
        [currentEnvironment]
    );

    const init = async () => {
        try {
            const response = await dashboardApi.getBlacklistedUsers()
            setBlacklistedUsers([...response.data]);
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
        } finally {
            setIsLoading(false)
        }
    };

    const removeUserFromBlacklist = async (email: string) => {
        setIsLoading(true)
        try {
            const response = await dashboardApi.removeUserFromBlacklist(email);
            if (response.data.message === 'user removed from the blacklist') {
                setBlacklistedUsers(prev => prev.filter(user => user.email !== email));
                setApiStatus({ code: HttpStatusCode.Ok, message: response.data.message });
            } else {
                setApiStatus({ code: HttpStatusCode.BadRequest, message: 'User has not been removed from blacklist' });
            }
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message });
        } finally {
            setIsLoading(false)
        }
    };


    if (isLoading) {
        return <div className="lds-hourglass" />
    }

    return <div className='pd-m main-dashboard-container mt-s'>
        <table className='center-wrapper table'>
            <thead className="table-header">
                <tr>
                    {
                        blacklistedUsersTableHeaders.map(
                            (header: string) => <th className="table-cell" key={header}>{header.toUpperCase()}</th>
                        )
                    }
                </tr>
            </thead>
            <tbody>
                {
                    blacklistedUsers.map(
                        (user: BlacklistedUsers, index: number) => (
                            <tr key={`${user._id}_${String(index)}`} className={'table-row'} >
                                <td className="table-cell selectable-text">{user.email}</td>
                                <td className="table-cell selectable-text">{user.macAddress ?? 'N/A'}</td>
                                {
                                    selectedBlacklistedUserEmails.includes(user.email) ? 
                                        <td className="table-cell">
                                            <button className='reset-button font-size-l' onClick={() => setSelectedBlacklistedUserEmails(prev => prev.filter(userEmail => userEmail !== user.email))}>❌</button>
                                            <button className='reset-button ml-s font-size-l' onClick={() => removeUserFromBlacklist(user.email)} >✅</button>
                                        </td> :
                                        <td className="table-cell">
                                            <button className='reset-button font-size-l' onClick={() => setSelectedBlacklistedUserEmails(prev => [...prev, user.email])}>❌</button>
                                        </td>
                                }
                            </tr>
                        )
                    )
                }
            </tbody>
        </table>
    </div>;
}
